module.exports = __webpack_public_path__ + "static/media/banner-newgames-web.3f424e85.jpg";